import React, { useEffect, useState } from 'react';
import './MainSearch.css';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ROUTES from '../../common/Routing/Routes';

function MainSearch() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState(searchParams.get('q') ?? '');

  useEffect(() => {
    setValue(searchParams.get('q') ?? '');
  }, [searchParams]);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      const query = value.trim();
      const nextParams = new URLSearchParams(searchParams);

      if (query.length >= 3) {
        nextParams.set('q', query);
      } else {
        nextParams.delete('q');
      }

      if (nextParams.toString() === searchParams.toString()) return;

      navigate({
        pathname: ROUTES.HOME,
        search: nextParams.toString(),
      }, { replace: true });
    }, 300);

    return () => window.clearTimeout(timeoutId);
  }, [navigate, searchParams, value]);

  return (
    <TextField
      id="main-search"
      className="main-search"
      fullWidth
      placeholder="Пошук книг"
      value={value}
      onChange={(event) => setValue(event.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        },
      }}
      variant="standard"
    />
  );
}

export default MainSearch;
